import { useTranslation } from 'react-i18next';

export default function WhyAurion() {
  const { t } = useTranslation();

  const reasons = [
    { key: 'razon1', icon: 'ri-360-line' },
    { key: 'razon2', icon: 'ri-money-euro-box-line' },
    { key: 'razon3', icon: 'ri-price-tag-3-line' },
    { key: 'razon4', icon: 'ri-building-4-line' },
    { key: 'razon5', icon: 'ri-leaf-line' },
    { key: 'razon6', icon: 'ri-customer-service-2-line' }
  ];

  return (
    <section id="por-que" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            {t('whyAurion.titulo')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('whyAurion.subtitulo')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {t(`whyAurion.${reason.key}.titulo`)}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t(`whyAurion.${reason.key}.descripcion`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
